import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getStackStyles } from './styles.js';
import { jsx } from '@emotion/react';

var _excluded = ["alignItems", "children", "noImportant", "scale"];
var Stack = function Stack(_ref) {
  var _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? 'stretch' : _ref$alignItems,
      children = _ref.children,
      noImportant = _ref.noImportant,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 's' : _ref$scale,
      props = _objectWithoutProperties(_ref, _excluded);
  return jsx("div", _extends({
    css: getStackStyles({
      scale: scale,
      alignItems: alignItems,
      noImportant: noImportant
    })
  }, props), children);
};
Stack.displayName = 'Stack';
Stack.defaultProps = {
  scale: 's',
  alignItems: 'stretch'
};

export { Stack };
//# sourceMappingURL=stack.js.map
